export default "__VITE_ASSET__r1ugzpFj__"